import { gsap } from 'gsap'
import { TextReveal } from '../../../modules/text-reveal'

function instant(ctx) {
	// gsap.set(ctx.container, { clearProps: 'all' })
	return null
}

function swup(ctx) {
	// return gsap.from(ctx.container, {
	// 	opacity: 0,
	// 	y: 12,
	// 	duration: 0.4,
	// })
	return null
}

function normalReveal(ctx) {
	const elProjectHeader = ctx.container.querySelector('.project__header')
	const elIcon = elProjectHeader.querySelector('.project__header__icon')
	const elText = elProjectHeader.querySelector('.project__header__text')

	const elTitleMain = elProjectHeader.querySelector('.project-title h1')
	const elTitleSub = elProjectHeader.querySelector('.project-title p')

	const elViews = elProjectHeader.querySelector('.project__header__views')

	const elImage = ctx.container.querySelector('.project__image')

	const elements = [elIcon, elText, elTitleMain, elTitleSub, elViews, elImage]

	// Desktop timeline
	const desktopTl = gsap.timeline({
		delay: 0.3,
		onComplete: () => {
			gsap.set(elements, { clearProps: 'all' })
		},
	})

	desktopTl.fromTo(
		elImage,
		{ scale: 0.8, opacity: 0 },
		{
			opacity: 1,
			scale: 1,
			y: 0,
			duration: 1.2,
			ease: 'power4.out',
		}
	)

	if (elIcon || elText) {
		desktopTl.fromTo(
			[elIcon, elText].filter(Boolean),
			{ y: 30, opacity: 0 },
			{
				y: 0,
				opacity: 1,
				duration: 1,
				ease: 'power3.out',
			},
			'-=0.8'
		)
	}
	desktopTl.fromTo(
		elTitleMain,
		{ y: 20, opacity: 0 },
		{
			y: 0,
			opacity: 1,
			duration: 1,
			ease: 'power4.out',
		},
		'-=0.8'
	)

	if (elTitleSub || elViews) {
		desktopTl.fromTo(
			[elTitleSub, elViews].filter(Boolean),
			{ y: 20, opacity: 0 },
			{
				y: 0,
				opacity: 1,
				duration: 1,
				ease: 'power4.out',
			},
			'-=0.8'
		)
	}

	// const elTitle = ctx.container.querySelector('.page-header h1')
	// const elImage = ctx.container.querySelector('.js-image-grid-reveal-source')

	// const textReveal = new TextReveal(elTitle, {
	// 	trigger: false,
	// 	manualReveal: true,
	// })

	// const revealTl = gsap.timeline({ delay: 0.3 })

	// revealTl
	// 	.add(() => {
	// 		textReveal.reveal()
	// 	})
	// 	.fromTo(
	// 		elImage,
	// 		{ scale: 0.8, opacity: 0 },
	// 		{
	// 			opacity: 1,
	// 			scale: 1,
	// 			y: 0,
	// 			duration: 1.2,
	// 			ease: 'power4.out',
	// 		},
	// 		'+=0.2'
	// 	)
}

export default {
	direct: normalReveal,
	swup: instant, // swup transitions handled elsewhere
	history: instant,
}
